import { siteInfo } from '@/mocks/site';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage' | 'CollectionPage';
  additionalData?: Record<string, unknown>;
}

export default function SchemaOrg({ type, additionalData = {} }: SchemaOrgProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: siteInfo.address,
        addressLocality: '北京',
        addressCountry: 'CN',
      },
      foundingDate: siteInfo.foundingYear,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
      inLanguage: 'zh-CN',
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: siteInfo.name,
      description: siteInfo.description,
      url: siteInfo.url,
      inLanguage: 'zh-CN',
      isPartOf: {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
      },
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      inLanguage: 'zh-CN',
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
    },
    CollectionPage: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      inLanguage: 'zh-CN',
    },
  };

  const schema = { ...baseSchemas[type], ...additionalData };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}